import { render, staticRenderFns } from "./message_check_with_subscribe.vue?vue&type=template&id=47b0bef6&scoped=true&"
import script from "./message_check_with_subscribe.vue?vue&type=script&lang=js&"
export * from "./message_check_with_subscribe.vue?vue&type=script&lang=js&"
import style0 from "./message_check_with_subscribe.vue?vue&type=style&index=0&id=47b0bef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b0bef6",
  null
  
)

export default component.exports